module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//snow_4_1.png?v=fa8758f8";